export const enum PlanType {
  FREE = 'FREE',
  PRO = 'PRO',
  PRO_PLUS_ORG = 'PRO+ORG',
  PRO_FLEX = 'PRO_FLEX',
  PILOT = 'PILOT',
  ENTERPRISE = 'ENTERPRISE'
}
